import styles from './progress-bar-section.module.scss';

export function UsedTimeIndicator({ usedWidth }: { usedWidth: string }) {
	return (
		<div className={styles.usedTimeIndicator} style={{ width: usedWidth }}>
			<div className={styles.line} />
			<div className={`${styles.tick} ${styles.tickLeft}`} />
			<div className={`${styles.tick} ${styles.tickRight}`} />
		</div>
	);
}
